import createVueComponent from '../createVueComponent';

const Clock2 = createVueComponent('Clock2Icon', [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['polyline', { points: '12 6 12 12 16 10' }],
]);

export default Clock2;
